<template>
  <base-modal
    id="connection-credentials-modal"
    ref="connection-credentials-modal"
    size="modal-md"
    :show="show"
    :show-close-button="true"
    @closed="close"
  >
    <template>
      <div
        class="credentials-modal"
      >
        <base-heading
          style="margin-bottom: 20px;"
        >
          Connect your livestream to Seer
        </base-heading>
        <hr>
        <base-text
          style="margin-top:34px;"
        >
          Here's the information you need for your streaming software.
        </base-text>
        <base-text
          semibold
          size="m"
          style="margin-top: 24px;"
        >
          1. Copy and enter your Server URL to your streaming software
        </base-text>
        <div
          class="copy-box"
        >
          <input
            id="stream-server"
            v-model="streamServer"
            readonly
            type="text"
            class="form-control copy-box__input"
            @keyup.enter="onKeyUp"
          >

          <span class="clickable copy-box__icon">
            <base-tooltip
              ref="createdLink"
              :text="serverTooltipText"
            >
              <base-icon
                icon="move-to-back"
                @click="copyToClipboard(streamServer, 'server', 'Copy Server URL')"
              />
            </base-tooltip>
          </span>
        </div>
        <base-text
          semibold
          size="m"
          style="margin-top: 44px;"
        >
          2. Copy and enter your Stream Key to your streaming software
        </base-text>
        <div
          class="copy-box"
        >
          <input
            id="stream-key"
            v-model="streamKey"
            readonly
            type="text"
            class="form-control copy-box__input"
            @keyup.enter="onKeyUp"
          >
          <span class="clickable copy-box__icon">
            <base-tooltip
              ref="createdLink"
              :text="keyTooltipText"
            >
              <base-icon
                icon="move-to-back"
                @click="copyToClipboard(streamKey, 'key', 'Copy Stream Key')"
              />
            </base-tooltip>
          </span>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>

export default {
  name: 'CredentialsModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    streamKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      serverTooltipText: 'Copy Server URL',
      keyTooltipText: 'Copy Stream Key',
      streamServer: 'rtmps://global-live.mux.com:443/app',
    };
  },
  methods: {
    copyToClipboard(text, varName, tipText) {
      this[`${varName}TooltipText`] = 'Copied to clipboard!';
      console.log(document.getElementById(`stream-${varName}`));
      document.getElementById(`stream-${varName}`).select();
      window.Clipboard.copy(text);
      setTimeout(() => {
        this[`${varName}TooltipText`] = tipText;
      }, 5000);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.header {

font-family: 'Tiempos';
font-style: normal;
font-weight: normal;
font-size: 20px;
line-height: 24px;
/* identical to box height, or 120% */

color: #333333;

}
::v-deep .modal-dialog {
    width: 594px;
    height: 365px;
    max-width: 100%;
}

::v-deep .modal-content {
    height: 365px;
}
.form-text {
  border: 0;
  width: 100%;
}
::v-deep .modal-body{
  padding: 0;
  padding-top: 27px;
}

::v-deep .form-control {
  &[readonly] {
    background-color: transparent !important;
  }
  &::selection {
    background-color: $bone;
  }
}
.copy-box {
  display: flex;
  align-items: center;
  margin-right: 0.625rem;
  padding-top: 9px;
  &__input {
    font-family: $font-family-sans-serif-light;
    padding: 0.55rem 2.7rem 0.55rem 0.8125rem ;
    border-radius: 5px;
    min-width: 100%;
  }
  &__icon{
    margin-left: -2.3rem;
  }
}
.credentials-modal {
  padding: 0 32px;
}
.code-box {
  border: 1px solid #D4D4D4;
  box-sizing: border-box;
  height: 36px;
  border-radius: 5px;
  padding-left: 13px;
  padding-right: 13px;
  padding-top: 9px;
  padding-bottom: 7px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
